<template>
  <div id="addstep">
    <Breadcrumb />
    <p class="sub-title prl70">SELECT MATERIAL AND COLOR</p>
    <div class="content middle collect mb50">
      <div class="cell">
        <!--  Start -->
        <div>
          <div class="container font14 dflex"
            :class="{ fcolumn: $store.getters.isVertical, frow: !$store.getters.isVertical }">
            <div class="row">
              <div class="col-xs-12 text-center mt30 inlineb mb30">
                <div class="inlineb p10 w100">
                  <div ref="printMe" class="inlineb">
                    <AlbaPanel v-if="type == 'alba'" />
                    <AriaPanel v-else-if="type == 'aria'" />
                    <AxesPanel v-else-if="type == 'axes'" />
                    <BlackJackPanel v-else-if="type == 'blackjack'" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row prl70" :class="{ pt100: $store.getters.isVertical }">
              <div class="col-xs-12 text-center">
                <div class="row prl70">
                  <div class="text-center"
                    :class="{ 'col-xs-6': !$store.getters.isVertical && withButtons, 'col-xs-12': $store.getters.isVertical || (!$store.getters.isVertical && !withButtons) }">
                    <p class="mb20" v-if="withButtons">FRAME</p>
                    <p class="mb20" v-else>SURFACE</p>
                    <div class="text-center col-xs-10 col-xs-offset-1">
                      <div v-for="(items, groupType) in frameSet[type]" :key="groupType" class="material-row">
                        <p class="material-row-title">{{ materialTitle[groupType] }}</p>
                        <el-radio v-for="item in items" :key="item.label" v-model="frameColor" :label="item.label"
                          :class="'material-type-' + groupType">
                          <div class="mlr10 inlineb">
                            <div class="border inlineb">
                              <img class="radio-side font20 click" :src="item.img" />
                            </div>
                            <p class="name-f">{{ item.title }}</p>
                          </div>
                        </el-radio>
                      </div>
                    </div>
                  </div>
                  <div class="text-center" :class="{
                    'col-xs-6': !$store.getters.isVertical, 'col-xs-12': $store.getters.isVertical,
                    'bdr-d': !$store.getters.isVertical, 'bdrt-d': $store.getters.isVertical
                  }" v-if="withButtons">
                    <p class="mb20">BUTTONS</p>
                    <div v-for="(items, groupType) in keySet" :key="groupType" class="material-row">
                      <p class="material-row-title">{{ materialTitle[groupType] }}</p>
                      <el-radio v-for="item in items" :key="item.label" v-model="keyColor" :label="item.label"
                        :class="'material-type-' + groupType">
                        <div class="mlr10 inlineb">
                          <div class="border inlineb">
                            <img class="radio-side font20 click" :src="item.img" />
                          </div>
                          <p class="name-f">{{ item.title }}</p>
                        </div>
                      </el-radio>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-footer white font16">
      <span class="click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import Breadcrumb from "./Panel/Breadcrumb";
import AlbaPanel from "./Panel/AlbaPanel";
import AriaPanel from "./Panel/AriaPanel";
import AxesPanel from "./Panel/AxesPanel";
import BlackJackPanel from "./Panel/BlackJackPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";
import { frameSetConfig, resolveMaterials, resolveButtonMaterials, materialTitle } from "../../store/materials";

export default {
  name: "s2",
  components: {
    Breadcrumb,
    AlbaPanel,
    AriaPanel,
    AxesPanel,
    BlackJackPanel
  },
  mixins: [artworkToProductMixin],
  data() {
    return {
      type: null,
      frameSet: {
        alba: resolveMaterials(frameSetConfig.alba), 
        aria: resolveMaterials(frameSetConfig.aria),
        axes: resolveMaterials(frameSetConfig.axes), 
        blackjack: resolveMaterials(frameSetConfig.blackjack), 
      },
      materialTitle: materialTitle
    };
  },

  methods: {
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },

    next() {
      this.$store.commit("getProductCode");
      //Go to next page
      this.$router.push({ path: "/collection/format/" + this.routeParamArtworkId });
    },
    back() {
      this.$store.commit("getProductCode");
      this.$router.push({ path: "/collection" });
    },
  },

  created: function () {
    if (!this.$store.state.artwork.type) {
      alert("Please go to the start page");
      this.$router.push({ path: "/collection/" });
    }
    this.$parent.headerB();
    this.$parent.headerNoBg();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 2;
    //read from store
    this.type = this.$store.state.artwork.type;
  },
  watch: {
    frameColor() {
      let keySet = Object.values(this.keySet).flat()
      
      if (keySet.length > 0 && keySet.findIndex(key => key.label == this.keyColor) == -1) {
        this.keyColor = keySet[0].label;
      }
    }
  },
  computed: {
    withButtons() {
      return this.type == 'alba' || this.type == 'blackjack';
    },
    frameColor: {
      get: function () {
        return this.$store.state.artwork.frameColor;
      },
      set: function (newValue) {
        this.$store.state.artwork.frameColor = newValue;

        if (this.type == "aria" || this.type == "axes") {
          this.$store.commit(
            "changeFontColor",
            this.$store.getters.getDefaultIconColor(
              this.$store.state.artwork.frameColor
            )
          );
        }
      },
    },
    keySet() {
      if (this.type == 'aria' || this.type == 'axes') {
        return {};
      }

      return resolveButtonMaterials(this.frameColor);
    },
    keyColor: {
      get: function () {
        return this.$store.state.artwork.keyColor;
      },
      set: function (newValue) {
        this.$store.state.artwork.keyColor = newValue;

        if (this.$store.getters.isFullMetal) {
          this.$store.commit("fullMetalSettings");
        } else {
          this.$store.commit("standardSettings");
        }

        if (this.type != "aria" && this.type != "axes") {
          this.$store.commit(
            "changeFontColor",
            this.$store.getters.getDefaultIconColor(
              this.$store.state.artwork.keyColor
            )
          );
        }
      },
    },
    format: {
      get: function () {
        return this.$store.state.artwork.format;
      },
      set: function (newValue) {
        this.$store.state.artwork.format = newValue;
      },
    },
    layout: {
      get: function () {
        return this.$store.state.artwork.layout;
      },
      set: function (newValue) {
        this.$store.state.artwork.layout = newValue;
        this.$store.state.artwork.layoutStyle = "iconOnly";
        this.$store.commit("getContent");
      },
    },
    rightLayout: {
      get: function () {
        return this.$store.state.artwork.rightLayout;
      },
      set: function (newValue) {
        this.$store.state.artwork.rightLayout = newValue;
        this.$store.state.artwork.rightLayoutStyle = "iconOnly";
        this.$store.commit("getRightContent");
      },
    },
    tripleRightLayout: {
      get: function () {
        return this.$store.state.artwork.tripleRightLayout;
      },
      set: function (newValue) {
        this.$store.state.artwork.tripleRightLayout = newValue;
        this.$store.state.artwork.tripleRightLayoutStyle = "iconOnly";
        this.$store.commit("getTripleRightContent");
      },
    },
  },
};
</script>

<style lang="css" scoped>
.nav-footer {
  border-top: 1px solid #ccc;
}
</style>
